import { MouseEventHandler, ReactNode } from 'react';

export enum InfoType {
  ERROR = 'error',
  WARNING = 'warning',
  TOOLTIP = 'tooltip',
  SUCCESS = 'success',
}

interface IValidationPrompt {
  accept?: string;
  reject?: string;
}

export type IInputInfoBoxUI = {
  message?: ReactNode;
  prompt?: IValidationPrompt;
  children?: ReactNode;
  onAccept?: MouseEventHandler;
  onReject?: MouseEventHandler;
  type?: InfoType;
};
